var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9687 6.92057C24.3 7.36239 24.2105 7.9892 23.7687 8.32057L17.3103 13.1643L17.3103 13.1643C15.8436 14.2643 13.8271 14.2643 12.3604 13.1643L12.3603 13.1643L5.90202 8.32062C5.46019 7.98925 5.37064 7.36245 5.70201 6.92062C6.03338 6.47879 6.66018 6.38925 7.10201 6.72062L13.5603 11.5643C14.3159 12.131 15.3548 12.131 16.1104 11.5643L22.5687 6.72057C23.0105 6.3892 23.6373 6.47874 23.9687 6.92057Z",
    fill: "#1BA397"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54427 6.43652C6.94596 6.43652 6.46094 6.92155 6.46094 7.51986V17.9365C6.46094 18.5348 6.94596 19.0199 7.54427 19.0199H22.1276C22.7259 19.0199 23.2109 18.5348 23.2109 17.9365V7.51986C23.2109 6.92155 22.7259 6.43652 22.1276 6.43652H7.54427ZM4.46094 7.51986C4.46094 5.81698 5.84139 4.43652 7.54427 4.43652H22.1276C23.8305 4.43652 25.2109 5.81698 25.2109 7.51986V17.9365C25.2109 19.6394 23.8305 21.0199 22.1276 21.0199H7.54427C5.84139 21.0199 4.46094 19.6394 4.46094 17.9365V7.51986Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ee45dad34ce58b69b4bd7e57aa2768ae.svg";
export { ForwardRef as ReactComponent };